import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import UtrHome from './views/UtrHome.vue'
import CopyupiHome from './views/UpiHome.vue'
import QrHome from './views/QrHome.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:orderno',
      name: 'home',
      component: Home
    },
    {
      path: '/utr/:orderno',
      name: 'utrhome',
      component: UtrHome
    },
    {
      path: '/copy/:orderno',
      name: 'copyupi',
      component: CopyupiHome
    },
    {
      path: '/qr/:orderno',
      name: 'qr',
      component: QrHome
    },
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ]
})
